export default {
  copyright: {
    en: '© 2025 GéniAle. All rights reserved.',
    fr: '© 2025 GéniAle. Tous droits réservés.',
  },
  our_socials: {
    en: 'Our socials',
    fr: 'Nos réseaux sociaux',
  },
  location: {
    en: '1219 William Street, Montréal, QC H3C 1K3',
    fr: '1219 rue William, Montréal, QC H3C 1K3',
  },
  room_number: {
    en: 'Room D-2017',
    fr: 'Local D-2017',
  },
};
